import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import {CustomerPortalModel} from './../Helpers/Interfaces/CustomerPortalModel';

export const CustomerPortalLayoutService = createApi({
  reducerPath: "CustomerPortalLayoutService",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  tagTypes: ["CustomersLayout"],
  endpoints: (builder) => ({
    getHomeCustomersLayout: builder.query<any, void>({
      query: () => ({
        url: `${ApiPath.customerHomeLayoutList}`,
        method: "GET",
      }),
      transformResponse: (response: { data: CustomerPortalModel[] }) => {
        return (response.data && response.data.length ? response.data[0]:{})
      },
      providesTags: ["CustomersLayout"],
    }),

    saveHomeCustomersLayout: builder.mutation<CustomerPortalModel, any>({
        query: (payload) => {
          // Check if this is an update request (has an id)
          if ('id' in payload) {
            return {
              url: `${ApiPath.customerHomeLayoutUpdate}/${payload.id}`,
              method: 'PUT',
              body: payload.data,
            };
          }
          // This is a create request
          return {
            url: ApiPath.customerHomeLayoutSave,
            method: 'POST',
            body: payload,
          };
        },
        invalidatesTags: ["CustomersLayout"],
      })
  }),
});

export const {
  useGetHomeCustomersLayoutQuery,
  useSaveHomeCustomersLayoutMutation
} = CustomerPortalLayoutService;
